import LoginEmailLinkSent from '@root/login/src/scenes/login-email-link-sent';
import LoginWithEmail from '@root/login/src/scenes/login-with-email';
import LoginWithEmailPassword from '@root/login/src/scenes/login-with-email-password';
import LoginWithEmailRetarget from '@root/login/src/scenes/login-with-email-retarget';
import PropTypes from '@root/vendor/prop-types';
import { Route, Switch } from '@root/core/src/components/route';

export default function LoginRouter({
  module,
  location,
  passProps,
  domain,
  isModuleInPath,
}) {
  const basePath = isModuleInPath ? `/${module}` : '';

  return (
    <Switch location={location}>
      <Route
        path={`${basePath}/login/email`}
        render={() => (
          <LoginWithEmail
            basePath={basePath}
            domain={domain}
            logout={passProps.onLogout}
            module={module}
          />
        )}
      />
      <Route
        path={`${basePath}/login/password`}
        render={() => (
          <LoginWithEmailPassword
            basePath={basePath}
            module={module}
            passProps={passProps}
          />
        )}
      />
      <Route
        path={`${basePath}/login/email-link-sent`}
        render={() => (
          <LoginEmailLinkSent
            basePath={basePath}
            module={module}
          />)
        }
      />
      <Route
        path={`${basePath}/login/welcome-back`}
        render={() => (
          <LoginWithEmailRetarget
            basePath={basePath}
            domain={domain}
            logout={passProps.onLogout}
            module={module}
          />
        )}
      />
    </Switch>
  );
}

LoginRouter.propTypes = {
  domain: PropTypes.string.isRequired,
  isModuleInPath: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  module: PropTypes.string.isRequired,
  passProps: PropTypes.object.isRequired,
};
